import { inject } from 'mobx-react';
import { LayoutComponent } from './component';
export const Layout = inject(({ ui, auth, mfeManager, tenant, userProfile }) => ({
    uiVersion: ui.uiVersion,
    loading: ui.loading,
    envLabel: ui.environmentLabel,
    hidden: ui.hideMenu,
    language: ui.language,
    nps: ui.nps,
    userData: auth.userData,
    pageTitle: ui.pageTitle,
    currentMfeState: mfeManager.currentMfeState,
    mfeStage: ui.mfeStage,
    tenant: tenant,
    // Lê `.profile` de propósito: o `inject` só observa o que o mapper acessa.
    // Passando a store crua, a chegada do perfil não re-renderizava.
    userProfile: { profile: userProfile.profile },
}))(LayoutComponent);
//# sourceMappingURL=index.js.map